import {Module} from '@fantasmagames/slot/src/common/Module';
import {RespinView} from 'src/respin/RespinView';
import {GameViews} from 'src/GameViews';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';
import {RespinEvents} from 'src/respin/RespinEvents';
import {ServerEvents} from '@fantasmagames/prototype/src/reels/ServerAvalancheReelsRound';
import {GameRecodeLogic} from 'src/logic/recode/GameRecodeLogic';
import {RoundTypes} from '@fantasmagames/slot/src/logic/integration/RecodeLogic';

export class RespinModule extends Module<RespinView> {
	protected enterFirstState(): void {
	}

	protected setupStates(): void {
	}

	protected setupViews(): void {
		this.setView(GameViews.RESPIN_VIEW);
	}

	protected setupEvents(): void {
		super.setupEvents();

		this.on(FlowModuleEvents.RESPIN_WON, this.onRespinWon);

		this.onViewEmitEvent(RespinView.LEAVING_RESPIN_SYMBOL, RespinEvents.LEAVING_SCATTER_AT);
		this.onViewEmitEvent(RespinView.SYMBOL_WAS_SHOT, RespinEvents.LEAVING_SYMBOL_AT);
		this.onViewEmitEvent(RespinView.RESPIN_END_ANIM_TRIGGERED, RespinEvents.END_ANIM_TRIGGERED);
		this.onViewEmitEvent(RespinView.FINISHED, RespinEvents.RESPIN_REMOVING_FINISHED);
	}

	protected onRespinWon(): void {
		const logic: GameRecodeLogic = (this.logic as GameRecodeLogic);
		if (logic.getNextRoundType() === RoundTypes.SCATTER_REPLACEMENT) {
			this.eventManager.emit(RespinEvents.RESPIN_STARTED);

			this.view.tryToStartRespinSymbols(
				logic.getSpinResult().respinScatters);
		} else {
			throw new Error('RecodeRespinModule::onRespinWon round type isn\'t RoundTypes.SCATTER_REPLACEMENT');
		}
	}
}



// WEBPACK FOOTER //
// ./src/respin/RespinModule.ts